import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TheNavigation from '@/components/navigation/TheNavigation.vue';
import TheFooter from '@/components/TheFooter.vue';
import { onMounted } from 'vue';
import { useTheme } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const theme = useTheme()

onMounted(() => {
  const savedTheme = localStorage.getItem('isDarkTheme')
  theme.global.name.value = savedTheme === 'true' ? 'dark' : 'light'
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      _createVNode(TheNavigation, { id: "scroll-target" }),
      _createVNode(_component_v_main, { class: "pt-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(TheFooter)
    ]),
    _: 1
  }))
}
}

})